import { SectionHeading } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/components/SectionHeading';
import { useApprovalDrawerViewOptimizationFlag } from '@/hooks/feature_flag/useApprovalDrawerViewOptimizationFlag';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { TransactionsDetailLayoutSwitch } from './LayoutSwitch';
import { TransactionsDetail } from './Table';

type TransactionsDetailSectionProps = {
  reportId: string;
};

export const TransactionsDetailSection: FC<TransactionsDetailSectionProps> =
  memo(({ reportId }) => {
    const { t } = useTranslation();
    const isLayoutSwitchEnabled = useApprovalDrawerViewOptimizationFlag();

    return (
      <SectionHeading title={t('approving_invoice_reports.transactions.title')}>
        {isLayoutSwitchEnabled ? (
          <TransactionsDetailLayoutSwitch reportId={reportId} />
        ) : (
          <TransactionsDetail reportId={reportId} />
        )}
      </SectionHeading>
    );
  });
TransactionsDetailSection.displayName = 'TransactionsDetailSection';
